import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'

import { Container } from './Portal.styled'

interface Props {
  modalIdentifier?: string
  children: React.ReactNode
  style?: React.CSSProperties
}

export const Portal = (props: Props): JSX.Element => {
  const refElement = useRef<HTMLDivElement>(document.createElement('div'))

  const { modalIdentifier, children, style } = props

  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    const modalRoot = document.getElementById(modalIdentifier || 'root')
    if (modalRoot) {
      modalRoot.appendChild(refElement.current)
      setMounted(true)
    }

    return () => {
      const modalRoot = document.getElementById(modalIdentifier || 'root')
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (modalRoot) modalRoot.removeChild(refElement.current)
    }
  }, [modalIdentifier])

  // eslint-disable-next-line import/no-named-as-default-member
  return ReactDOM.createPortal(<Container style={style}>{mounted && children}</Container>, refElement.current)
}
